import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "pt-select-wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 1,
  class: "text-body--sm pt-select__error",
  "data-testid": "pt-select-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.inputId,
          class: "text-heading--sm pt-form-label",
          "data-testid": "pt-select-label"
        }, _toDisplayString(_ctx.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_Select, {
      "data-testid": "pt-select-control",
      modelValue: _ctx.internalValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalValue) = $event)),
      options: _ctx.options,
      "option-label": _ctx.optionLabel,
      "option-value": _ctx.optionValue,
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      invalid: _ctx.invalid,
      filter: _ctx.filter,
      "filter-match-mode": _ctx.filterMatchMode,
      "filter-fields": _ctx.filterFields,
      editable: _ctx.editable,
      "highlight-on-select": _ctx.highlightOnSelect,
      "show-clear": _ctx.showClear,
      "reset-filter-on-hide": _ctx.resetFilterOnHide,
      "scroll-height": _ctx.scrollHeight,
      "auto-filter-focus": false,
      "select-on-focus": false,
      "focus-on-hover": false,
      name: _ctx.name,
      "input-id": _ctx.inputId,
      "data-key": _ctx.dataKey,
      "aria-label": _ctx.ariaLabel,
      "aria-labelledby": _ctx.ariaLabelledby,
      loading: _ctx.loading,
      "loading-icon": _ctx.loadingIcon,
      "dropdown-icon": _ctx.dropdownIcon,
      "append-to": _ctx.appendTo,
      onFocus: _ctx.onFocus,
      onBlur: _ctx.onBlur,
      onShow: _ctx.onShow,
      onHide: _ctx.onHide,
      onFilter: _ctx.onFilter
    }, _createSlots({
      default: _withCtx(() => [
        (_ctx.$slots.emptyfilter)
          ? _renderSlot(_ctx.$slots, "emptyfilter", {}, undefined, undefined, 0)
          : _createCommentVNode("", true),
        (_ctx.$slots.empty)
          ? _renderSlot(_ctx.$slots, "empty", {}, undefined, undefined, 1)
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.$slots.value)
        ? {
            name: "value",
            fn: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "value", _normalizeProps(_guardReactiveProps(slotProps)))
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.$slots.header)
        ? {
            name: "header",
            fn: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "header", _normalizeProps(_guardReactiveProps(slotProps)))
            ]),
            key: "1"
          }
        : undefined,
      (_ctx.$slots.footer)
        ? {
            name: "footer",
            fn: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "footer", _normalizeProps(_guardReactiveProps(slotProps)))
            ]),
            key: "2"
          }
        : undefined,
      (_ctx.$slots.option)
        ? {
            name: "option",
            fn: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "option", _normalizeProps(_guardReactiveProps(slotProps)))
            ]),
            key: "3"
          }
        : undefined,
      (_ctx.$slots.optiongroup)
        ? {
            name: "optiongroup",
            fn: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "optiongroup", _normalizeProps(_guardReactiveProps(slotProps)))
            ]),
            key: "4"
          }
        : undefined,
      (_ctx.$slots.loadingicon)
        ? {
            name: "loadingicon",
            fn: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "loadingicon", _normalizeProps(_guardReactiveProps(slotProps)))
            ]),
            key: "5"
          }
        : undefined,
      (_ctx.$slots.dropdownicon)
        ? {
            name: "dropdownicon",
            fn: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "dropdownicon", _normalizeProps(_guardReactiveProps(slotProps)))
            ]),
            key: "6"
          }
        : undefined,
      (_ctx.$slots.clearicon)
        ? {
            name: "clearicon",
            fn: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "clearicon", _normalizeProps(_guardReactiveProps(slotProps)))
            ]),
            key: "7"
          }
        : undefined
    ]), 1032, ["modelValue", "options", "option-label", "option-value", "placeholder", "disabled", "invalid", "filter", "filter-match-mode", "filter-fields", "editable", "highlight-on-select", "show-clear", "reset-filter-on-hide", "scroll-height", "name", "input-id", "data-key", "aria-label", "aria-labelledby", "loading", "loading-icon", "dropdown-icon", "append-to", "onFocus", "onBlur", "onShow", "onHide", "onFilter"]),
    (_ctx.invalid && _ctx.errorText)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.errorText), 1))
      : _createCommentVNode("", true)
  ]))
}